var React = require('react');

function TestBot (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m49.258 70h40.742v-56.668h-80v56.668h23.332v16.461zm-1.4141-3.332h38.824v-50h-73.336v50h23.336v11.555z","fillRule":"evenodd"}));
}

TestBot.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = TestBot;

TestBot.default = TestBot;
